module.exports = __webpack_public_path__ + "static/img/aiqc-defect-line.b8153b90.jpg";